import { Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Guid } from 'guid-typescript';
import { IESignInputModel, IPlaceIneRegBinder, ITabs, ViewerContentType, DocumentType, NotificationType, IPortalConfig, IViewerParams } from 'src/app/models';
import { DomSanitizer } from '@angular/platform-browser';
import { EpaSignatureComponent } from '../epa-signature/epa-signature.component';
import { PlaceInRegdocComponent } from '../place-in-regdoc/place-in-regdoc.component';
import { DocumentViewerAiChatComponent } from '../document-viewer-ai-chat/document-viewer-ai-chat.component';
import { DocumentService, CommunicationService, LoggingService, PortalService, LoaderService, SecurityService, AuthorizationService } from 'src/app/services';
import { environment } from 'src/environments/environment';
import _, { stubFalse } from 'lodash';
import { TopNotificationService } from 'src/app/shared/components/top-notification/top-notification.service';
import { Helpers } from 'src/app/helpers';
import { TrainingService } from 'src/app/services/training.service';
import moment from 'moment';
import { MasterLogService } from 'src/app/shared/directives/medpt-common-event-log';
import * as FileSaver from 'file-saver';
import { Actions, AssetTracking, AssetViewSources } from 'src/app/models/document/assettracking';
import { Constants } from '../../models/constants';

@Component({
    selector: 'medpt-document-viewer',
    templateUrl: './document-viewer.component.html',
    styleUrls: ['./document-viewer.component.scss'],
    standalone: false
})
export class DocumentViewerComponent implements OnInit, OnDestroy {

  @ViewChild(MatTabGroup, { read: MatTabGroup }) public tabGroup!: MatTabGroup;
  @ViewChildren(MatTab, { read: MatTab }) public tabNodes!: QueryList<MatTab>;
  @ViewChild('viewerAiChat') public viewerAiChat?: DocumentViewerAiChatComponent;

  @Input() tabData!: ITabs;
  @Output() updateSignatureEvent: EventEmitter<any> = new EventEmitter();
  viewerContentType = ViewerContentType;
  tabs: Array<ITabs> = [];
  portalInfo: IPortalConfig;
  chatDocumentContext: any = null;
  isAiChatAvailable = false;
  isAiChatOpen = false;
  enableAIAssistant: boolean = false;
  // AI Insights
  enableAIInsights: boolean = false;
  isAiInsightsOpen = false;
  aiInsightsDocName = '';
  aiInsightsAssetId: number | null = null;

  constructor(
    public modal: NgbActiveModal,
    private modelDialogService: NgbModal,
    private loaderService: LoaderService,
    private sanitizer: DomSanitizer,
    private documentService: DocumentService,
    private trainingService: TrainingService,
    private communicationService: CommunicationService,
    private elRef: ElementRef,
    private loggingService: LoggingService,
    private notificationService: TopNotificationService,
    private portalService: PortalService,
    private securityService: SecurityService,
    private masterLogService: MasterLogService,
    private authorizationService: AuthorizationService
  ) {
    this.portalInfo = this.portalService.portalConfiguation.getValue();
  }

  ngAfterViewChecked() {
    if (!Helpers.isNullOrUndefined(this.tabData.htmlContent)) {
      let div = this.elRef.nativeElement.querySelectorAll('#div_' + this.tabData.tabId + ' a');
      if (div.length > 0) {
        for (let i = 0; i < div.length; i++) {
          this.elRef.nativeElement.querySelectorAll('#div_' + this.tabData.tabId + ' a')[i].onclick = (e: any) => {
            if (this.tabData.DocumentType == DocumentType.SafetyReport) {
              this.openSusarDocumentLink(e.target.getAttribute('data-susardilid'), e.target.getAttribute('data-assetid'), e.target.getAttribute('data-title'), e.target.getAttribute('data-susarassetstatusid'), e.target.getAttribute('data-placeInRegDocEnabled') == "true", e.target.getAttribute('data-issusarexists') == "true",e.target.getAttribute('data-isfromRelatedGrid'));
 }
            else {
              let param = (<string>e.currentTarget.attributes['data-onclick'].value).replaceAll("OpenMessageDocumentLink", "").replaceAll('(', '').replaceAll(')', '');
              let arr = param.split(',');
              this.openMessageDocumentLink(arr[0].replaceAll('"', '').replaceAll("'", '').replaceAll("'", '').trim(), arr[1].replaceAll('"', '').replaceAll("'", '').replaceAll("'", '').trim());
            }
          }
        }
      }
    }
  }

  ngOnInit(): void {
    this.addTab(this.tabData);
    this.enableAIInsights = this.tabData.EnableAIInsights || false;
    if(this.authorizationService.isNavigationOrFeatueAllowed(Constants.RASPberryAI_AIAssistant_FEATURE_NAME))
    {
      this.enableAIAssistant = true;
    }

    this.refreshChatDocumentContext();
  }

  ngOnDestroy() {
    this.updateSignatureEvent.unsubscribe();
    if (this.sessionUpdateInterval != null) {
      clearInterval(this.sessionUpdateInterval);
      this.sessionUpdateInterval = null;
    }
   }

  private refreshChatDocumentContext() {
    this.chatDocumentContext = this.buildDocumentContext();
  }

  openAiAssistant() {
    this.viewerAiChat?.openChatPanel();
  }

  onChatAvailabilityChange(isAvailable: boolean) {
    this.isAiChatAvailable = isAvailable;
  }

  onChatOpenStateChange(isOpen: boolean) {
    this.isAiChatOpen = isOpen;
  }

  openAiInsightsModal(tab: ITabs) {
    this.aiInsightsDocName = <string>tab.name;
    this.aiInsightsAssetId = <number>tab.AssetId;
    this.isAiInsightsOpen = true;
  }

  closeAiInsightsModal() {
    this.isAiInsightsOpen = false;
    this.aiInsightsAssetId = null;
  }

  onCitationNavigate(citation: { documentId: string; pageNumber: number; searchText: string; Source: string }) {
    this.openDocumentWithCitation(citation.documentId, citation.pageNumber, citation.searchText, citation.Source);
  }

  openDocumentWithCitation(documentId: string, pageNumber: number, searchText: string, score?: string) {
    const assetId = parseInt(documentId, 10);
    if (Number.isNaN(assetId)) {
      return;
    }

    const citationTabIndex = _.findIndex(this.tabs, (item) => item.AssetId == assetId);
    if (citationTabIndex > -1) {
      this.tabGroup.selectedIndex = citationTabIndex;
      this.refreshViewerTabWithCitation(this.tabs[citationTabIndex], pageNumber, searchText, score);
      return;
    }

    this.loaderService.showLoader();
    this.documentService.getDocumentUrlByAssetId(<string>this.portalInfo.SponsorName, <number>this.portalInfo.PortalID, assetId).then((result: any) => {
      if (!result.SuccessFlag) {
        this.notificationService.showNotification("You do not have permission to view this document.", NotificationType.Error);
        return;
      }

      const params: IViewerParams = {
        DocumentUrl: result.Type == "URL" ? result.ViewingSessionID : "",
        ViewingSessionId: result.Type != "URL" ? result.ViewingSessionID : "",
        DownloadCallbackFunction: "DownloadDocument",
        DownloadCallbackFunctionParam: result.PersonAssetGuid,
        Anontation: false,
        Download: result.IsDownloadable,
        Print: result.IsDownloadable,
        PageNumber: pageNumber,
        SearchText: searchText?.split(/\s+/).slice(0, 3).join(' '),
        Score: score,
        CitationBoundary: score
      };

      const queryParam = btoa(unescape(encodeURIComponent(JSON.stringify(params))));
      const contentUrl = environment.viewerAppUrl + 'viewer/index';
      const tabData: ITabs = {
        AssetId: assetId,
        DocumentType: DocumentType.Document,
        DocumentPath: result.DocumentPath,
        contentUrl: contentUrl,
        htmlContent: "",
        name: result.AssetName,
        PersonAssetGuid: result.PersonAssetGuid,
        PersonAssetId: result.PersonAssetID,
        showPlaceInRegDoc: result.IsDownloadable && result.EnablePlaceInRegDoceSafe,
        showPrintButton: false,
        showSignButton: result.Status.toLowerCase() == 'click to sign',
        SusarAssetStatusId: 0,
        ViewerContentType: ViewerContentType.Document,
        viewerToken: queryParam
      };

      this.addTab(tabData, true);
    }).catch((err) => {
      this.loggingService.Error(
        `<MedPoint.WebApp.TriPort.Shared.DocumentViewerComponent.openDocumentWithCitation> Failed with message=${JSON.stringify(err)}`
      );
      this.notificationService.showNotification("Failed to open document.", NotificationType.Error);
    }).finally(() => {
      this.loaderService.hideLoader();
    });
  }

  private refreshViewerTabWithCitation(tab: ITabs, pageNumber: number, searchText: string, score?: string) {
    if (Helpers.isNullOrUndefined(tab) || tab.ViewerContentType != ViewerContentType.Document || Helpers.isNullOrUndefined(tab.viewerToken)) {
      return;
    }

    const viewerParams = <IViewerParams>(JSON.parse(decodeURIComponent(escape(atob(<string>tab.viewerToken)))));
    viewerParams.PageNumber = pageNumber;
    viewerParams.SearchText = searchText?.split(/\s+/).slice(0, 3).join(' ');
    viewerParams.Score = score;
    viewerParams.CitationBoundary = score;

    tab.viewerToken = btoa(unescape(encodeURIComponent(JSON.stringify(viewerParams))));
    tab.IsFormSubmitted = false;

    this.loaderService.showLoader();
    setTimeout(() => {
      const formId = `#viewerform_${tab.tabId}`;
      if ($(formId).length) {
        $(formId).submit();
        tab.IsFormSubmitted = true;
      } else {
        this.loaderService.hideLoader();
      }
    });
  }

  private buildDocumentContext() {
    const selectedIndex = typeof this.tabGroup?.selectedIndex === 'number' ? this.tabGroup.selectedIndex : this.tabs.length - 1;
    const activeTab = this.tabs[selectedIndex] ?? this.tabData;
    return {
      documentId: activeTab?.AssetId,
      documentName: activeTab?.name,
      documentType: activeTab?.DocumentType,
      viewerContentType: activeTab?.ViewerContentType,
      hasContentUrl: !!activeTab?.hasContentUrl,
      hasHtmlContent: !!activeTab?.hashHtmlContent,
      htmlPreview: this.getHtmlPreview(activeTab?.hashHtmlContent ? <string>activeTab?.htmlContent : ''),
      tabCount: this.tabs.length,
      generatedAt: new Date().toISOString()
    };
  }

  private getHtmlPreview(htmlText: string): string {
    if (Helpers.isNullOrUndefined(htmlText) || htmlText.trim() === '') {
      return '';
    }

    const plainText = htmlText.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    return plainText.substring(0, 800);
  }

  removeTab($event: any, index: number) {
    $event.stopPropagation();
    this.tabs = _.filter(this.tabs, (item) => { return <string>item.name != <string>this.tabs[index].name });
    if (this.tabs.length == 0) {
      this.removeAllTab();
    } else {
      this.refreshChatDocumentContext();
    }
  }

  removeAllTab() {
    this.tabs = [];
    this.modal.close('');
    this.updateSignatureEvent.next(true);
    if (this.sessionUpdateInterval != null) {
      clearInterval(this.sessionUpdateInterval);
      this.sessionUpdateInterval = null;
    }
  }

  addTab(currentTabData: ITabs, goLastTab: boolean = true) {
    currentTabData.tabId = Guid.create().toString() + '-' + moment().unix().toString();
    currentTabData.hasContentUrl = false;
    currentTabData.hashHtmlContent = false;

    if (!Helpers.isNullOrUndefined(currentTabData.contentUrl)) {
      currentTabData.hasContentUrl = true;
      currentTabData.contentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(<string>currentTabData.contentUrl);
    }
    else if (!Helpers.isNullOrUndefined(currentTabData.htmlContent)) {
      currentTabData.hashHtmlContent = true;
      currentTabData.htmlContent = <string>currentTabData.htmlContent?.replaceAll("onclick", "data-onclick");
      currentTabData.showPrintButton = currentTabData.showPrintButton;
    }
    if (currentTabData.showSignButton || currentTabData.showPlaceInRegDoc || currentTabData.showPrintButton) {
      currentTabData.hasViewerButtons = true;
    }

    this.tabs = _.filter(this.tabs, (item) => { return <string>item.name != <string>currentTabData.name });
    this.tabs.push(currentTabData);

    if (currentTabData.hasContentUrl && this.tabs.length == 1) {
      $(document).ready(() => {
        $(`#viewerform_${currentTabData.tabId}`).submit();
      });
      this.tabs[0].IsFormSubmitted = true;
    }

    if (this.tabNodes != undefined) {
      if (goLastTab) {
        this.tabGroup.selectedIndex = this.tabNodes.length;
      }
    }
    if (currentTabData.ViewerContentType != ViewerContentType.HtmlContent && goLastTab)
      this.loaderService.showLoader();

    if (currentTabData.ViewerContentType != ViewerContentType.Document && currentTabData.ViewerContentType != ViewerContentType.ScormPlayer)
      this.loaderService.hideLoader();

    if (currentTabData.DocumentType == DocumentType.Training) {
      this.updateSession();
    }

    this.refreshChatDocumentContext();
  }

  sessionUpdateInterval: any = null;
  updateSession() {
    this.sessionUpdateInterval = setInterval(() => {
      this.securityService.manageUserSession(1);
    }, 60 * 1000 * 5);
  }

  openMessageDocumentLink(assetName: string, assetGUID: string) {
    let tabs = _.filter(this.tabs, (item) => { return <string>item.name == <string>assetName; });
    if (tabs.length == 0) {
      this.loaderService.showLoader();
      this.loggingService.Info(
        `<MedPoint.WebApp.TriPort.Shared.DocumentViewerComponent.openMessageDocumentLink> begins.`
      );
      this.documentService.getDocumentLinkURLByAssetGUID(<string>this.portalInfo.SponsorName, <number>this.portalInfo.PortalID, assetGUID).then((result) => {
        if (result.SuccessFlag) {
          let params: IViewerParams = {
            DocumentUrl: result.Type == "URL" || <string>(result.ViewingSessionID).includes('blob.core.windows.net') ? result.ViewingSessionID : "",
            ViewingSessionId: result.Type != "URL" || !<string>(result.ViewingSessionID).includes('blob.core.windows.net') ? result.ViewingSessionID : "",
            DownloadCallbackFunction: "DownloadDocument",
            DownloadCallbackFunctionParam: result.PersonAssetGuid,
            Anontation: false,
            Download: true,
            Print: true
          };
          let queryParam = btoa(unescape(encodeURIComponent(JSON.stringify(params))));
          let CONTENTURL = environment.viewerAppUrl + 'viewer/index';
          //let CONTENTURL = <string>environment.viewerAppUrl + 'viewer/index?' + (result.Type == "URL" ? 'document=' + encodeURIComponent(result.ViewingSessionID) : "viewingsessionid=" + result.ViewingSessionID) + "&dnCallbkFn=DownloadDocument&dnCallbkFnParam=" + result.PersonAssetGuid;
          let tabData: ITabs = { hasViewerButtons: result.EnablePlaceInRegDoceSafe || result.Status.toLowerCase() == 'haselectronicsignature', hasContentUrl: true, AssetId: result.PersonAssetGuid, DocumentType: DocumentType.Document, DocumentPath: result.DocumentPath, contentUrl: CONTENTURL, htmlContent: "", name: assetName, PersonAssetGuid: result.PersonAssetGuid, PersonAssetId: result.PersonAssetID, showPlaceInRegDoc: result.EnablePlaceInRegDoceSafe, showPrintButton: false, showSignButton: result.Status.toLowerCase() == 'click to sign', SusarAssetStatusId: 0, ViewerContentType: ViewerContentType.Document, viewerToken: queryParam };

          this.addTab(tabData);
        } else {
          this.loaderService.hideLoader();
          this.notificationService.showNotification("Failed to open document.", NotificationType.Error);
        }
      })
        .catch((err) => {
          this.loaderService.hideLoader();
          this.loggingService.Error(
            `<MedPoint.WebApp.TriPort.Shared.DocumentViewerComponent.openMessageDocumentLink> Failed with message=${JSON.stringify(err)}`
          );
          this.notificationService.showNotification("Failed to open document.", NotificationType.Error);
        })
        .finally(() => {
          this.loggingService.Info(
            `<MedPoint.WebApp.TriPort.Shared.DocumentViewerComponent.openMessageDocumentLink> ends.`
          );
        });
    } else {
      let tabIndex = _.findIndex(this.tabs, (item) => { return <string>item.name == <string>assetName; });
      this.tabGroup.selectedIndex = tabIndex;
    }
  }

  /*
  addNewTab($event: any, tabData: ITabs) {

    const demoData = Object.assign({}, tabData);
    demoData.contentUrl = "";
    demoData.hasContentUrl = false;
    demoData.htmlContent = `<p>Dear All</p>
                        <p>Please be reminded that IVRS should not be contacted to re-screen patients.</p>
                        <p>IVRS is to be contacted at V1 to enter patients into screening and then either at V2 to randomize the patient or once the patient is determined to be a screen failure (and no rescreening is planned).</p>
                        <p>Contacting IVRS when rescreening patients can result in patients being inadvertently randomized.</p>
                        <p>If you have any questions regarding the above please contact your site monitor.</p>
                        <p>Many thanks for your ongoing support for this study</p>
                        <br/>
                        <p>The Team</p>`;
    demoData.hashHtmlContent = true;
    demoData.showPlaceInRegDoc = false;
    demoData.showPrintButton = true;
    demoData.showSignButton = false;
    demoData.name = "Demo Tab " + this.tabs.length;
    demoData.ViewerContentType = ViewerContentType.HtmlContent;
    this.addTab(demoData);
    this.loaderService.hideLoader();
  }
  */

  getToken() {
    var currentUser = this.securityService.currentUserValue;
    if (currentUser != null)
      return this.securityService.currentUserValue.Token;
    else {
      return "";
    }
  }

  onTabSelectedIndexChange($index: number) {
    if ($index != -1) {
      this.tabData = this.tabs[$index];
      this.refreshChatDocumentContext();
      if (this.tabs[$index].ViewerContentType == ViewerContentType.Document && !this.tabs[$index].IsFormSubmitted) {
        this.masterLogService.postLogMessage("Click","Selected is ViewerContentType as Document ");     
        this.tabs[$index].IsFormSubmitted = true;
        this.loaderService.showLoader();
        const formId = `#viewerform_${this.tabs[$index].tabId}`;
        const interval = setInterval(() => {
          if ($(formId).length) {
            $(formId).submit();
            clearInterval(interval);
          }
        }, 100);
      }
      if (this.tabs[$index].ViewerContentType == ViewerContentType.Document) {
        setTimeout(() => {
          if (this.tabs[$index].StatusUpdatePromise != undefined) {
            this.updateSignatureEvent.next(this.tabs[$index].AssetId);
            this.tabs[$index].StatusUpdatePromise?.subscribe((result) => {
              result.AssetId = this.tabs[$index].AssetId;
              this.tabs[$index].showSignButton = result.Status.toLowerCase() == 'haselectronicsignature';
              this.updateSignatureEvent.next(result);
              this.tabs[$index].StatusUpdatePromise = undefined;
            }, (error) => { console.log(error); });
          }
        });
      }
    }
  }

  onLoadediframe(elm: any) {
    setTimeout(() => { this.loaderService.hideLoader(); });
  }

  openSignatureModal($event: any, tab: ITabs) {
    let modelData: IESignInputModel = { AssetId: tab.AssetId, IsSelected: true, PersonAssetGuid: <string>tab.PersonAssetGuid, Title: tab.name, DocumentType: tab.DocumentType!,showDocument:true,selectedTypeId:null, HasMultiplePortalAssignments:(tab.HasMultipleAssignment == undefined || tab.HasMultipleAssignment == null|| tab.HasMultipleAssignment  == "False" )? false : true };
    let modalInstance = this.modelDialogService.open(EpaSignatureComponent, { size: 'lg', scrollable: true });
    modalInstance.componentInstance.eSignInputModel = modelData;
    modalInstance.componentInstance.updateSignatureEvent.subscribe((receivedEntry: any) => {
      this.updateSignatureEvent.next(receivedEntry);
      if (receivedEntry) {
        tab.showSignButton = false;
        if (tab.DocumentType == DocumentType.SafetyReport) {
          this.loaderService.showLoader();

          this.communicationService.getSusarUrl(<number>tab.SusarDILID, false, <number>tab.SiteId).then((result: any) => {
            this.loaderService.showLoader();
            let params: IViewerParams = {
              DocumentUrl: result.Type == "URL" ? result.ViewingSessionID : "",
              ViewingSessionId: result.Type != "URL" ? result.ViewingSessionID : "",
              DownloadCallbackFunction: "DownloadDocument",
              DownloadCallbackFunctionParam: <any>tab.SusarAssetStatusId,
              Anontation: false,
              Download: true,
              Print: true
            };
            let queryParam = btoa(unescape(encodeURIComponent(JSON.stringify(params))));

            tab.viewerToken = queryParam;
            setTimeout(() => {
              $(`#viewerform_${tab.tabId}`).submit();
            });  
            this.loaderService.hideLoader();          
          })
            .catch((err) => {
              this.loaderService.hideLoader();
              this.loggingService.Error(
                `<MedPoint.WebApp.TriPort.Shared.DocumentViewerComponent.openSusarDocumentLink> Failed with message=${JSON.stringify(err)}`
              );
              this.notificationService.showNotification("Failed to open safety report.", NotificationType.Error);
            })
            .finally(() => {
              this.loaderService.hideLoader();
              this.loggingService.Info(
                `<MedPoint.WebApp.TriPort.Shared.DocumentViewerComponent.openSusarDocumentLink> ends.`
              );
            });
          
        }
      }
    });
  }

  openSusarDocumentLink(susarDILID: number, assetId: number, susartitle: string, susarAssetStatusId: number, placeInRegDocEnabled: boolean, issusarexists: boolean = true, isfromRelatedGrid : boolean) {
    let tabs = _.filter(this.tabs, (item) => { return <string>item.name == <string>susartitle; });
    if (tabs.length == 0) {
      this.loaderService.showLoader();
      this.loggingService.Info(
        `<MedPoint.WebApp.TriPort.Shared.DocumentViewerComponent.openSusarDocumentLink> begins.`
      );
      if (susarDILID != null) {
        this.communicationService.getSusarUrl(susarDILID, true, tabs.length != 0 && tabs[0].SiteId != undefined ? tabs[0].SiteId : 0).then((result: any) => {
          if (result.SuccessFlag) {
            let params: IViewerParams = {
              DocumentUrl: result.Type == "URL" ? result.ViewingSessionID : "",
              ViewingSessionId: result.Type != "URL" ? result.ViewingSessionID : "",
              DownloadCallbackFunction: "DownloadDocument",
              DownloadCallbackFunctionParam: <any>susarAssetStatusId,
              Anontation: false,
              Download: true,
              Print: true
            };
            let queryParam = btoa(unescape(encodeURIComponent(JSON.stringify(params))));
            let CONTENTURL = environment.viewerAppUrl + 'viewer/index';
            //let CONTENTURL = <string>environment.viewerAppUrl + 'viewer/index?' + (result.Type == "URL" ? 'document=' + encodeURIComponent(result.ViewingSessionID) : "viewingsessionid=" + result.ViewingSessionID) + "&dnCallbkFn=DownloadDocument&dnCallbkFnParam=" + <number>susarAssetStatusId;
            let showSignButton ;
            if(this.tabData.SRGridList!=  undefined && isfromRelatedGrid){
            if (_.filter(this.tabData.SRGridList, (x) => { return x.AssetID == assetId }).length > 0) {
              showSignButton = result.Status.toLowerCase() == 'haselectronicsignature' && issusarexists ;
            }
            else{
              showSignButton = false;
            }
           }
           else{
            showSignButton = result.Status.toLowerCase() == 'haselectronicsignature' && issusarexists;
           }
           
            let tabData: ITabs = { AssetId: assetId, DocumentType: DocumentType.SafetyReport, DocumentPath: result.DocumentPath, contentUrl: CONTENTURL, htmlContent: '', name: susartitle, PersonAssetGuid: '', PersonAssetId: 0, showPlaceInRegDoc: placeInRegDocEnabled, showPrintButton: false, showSignButton: showSignButton, SusarAssetStatusId: susarAssetStatusId, ViewerContentType: ViewerContentType.Document, hasContentUrl: true, hasViewerButtons: placeInRegDocEnabled || showSignButton, SusarDILID: susarDILID, viewerToken: queryParam,
              SiteId: this.tabs[0].SiteId
             };
            if (issusarexists) {
              result.AssetId = parseInt(assetId.toString());
              this.updateSignatureEvent.next(result);
            }
            this.addTab(tabData);
          } else {
            this.loaderService.hideLoader();
            this.notificationService.showNotification("Failed to open safety report.", NotificationType.Error);
          }
        })
          .catch((err) => {
            this.loggingService.Error(
              `<MedPoint.WebApp.TriPort.Shared.DocumentViewerComponent.openSusarDocumentLink> Failed with message=${JSON.stringify(err)}`
            );
            this.notificationService.showNotification("Failed to open safety report.", NotificationType.Error);
          })
          .finally(() => {
            this.loggingService.Info(
              `<MedPoint.WebApp.TriPort.Shared.DocumentViewerComponent.openSusarDocumentLink> ends.`
            );
          });
      }
    } else {
      let tabIndex = _.findIndex(this.tabs, (item) => { return <string>item.name == <string>susartitle; });
      this.tabGroup.selectedIndex = tabIndex;
    }
  }

  openPlaceInRegDocModal($event: any, tab: ITabs) {
    let viewerParams = tab.viewerToken != undefined ? <IViewerParams>(JSON.parse(decodeURIComponent(escape(atob(tab.viewerToken!))))) : null; 
    let placeIneRegBinder: IPlaceIneRegBinder = {
      eRegDoc: { SiteGuid: Guid.createEmpty().toString(), BinderGuid: Guid.createEmpty().toString() },
      AssetId: tab.AssetId,
      DocumentPath: Helpers.isNullOrUndefined(tab.DocumentPath) || tab.DocumentPath == '' ? '' : tab.DocumentPath!,
      DocumentType: tab.DocumentType!,
      PlaceSameFile: false,
      HtmlText: tab.hashHtmlContent ? <string>tab.htmlContent : "",
      Title: tab.name,
      PersonAssetGuid: Helpers.isNullOrUndefined(tab.PersonAssetGuid) || tab.PersonAssetGuid == '' ? Guid.createEmpty().toString() : <string>tab.PersonAssetGuid!,
      ViewingSessionId: tab.DocumentType == DocumentType.SafetyReport && viewerParams != null && viewerParams.ViewingSessionId != "" ? viewerParams.ViewingSessionId : "" ,
      SiteId : tab.SiteId
    };
    let modalInstance = this.modelDialogService.open(PlaceInRegdocComponent, { size: 'lg', scrollable: true });
    modalInstance.componentInstance.placeIneRegBinder = placeIneRegBinder;
  }

  DownloadDocument(args: any) {
    if (!Helpers.isNullOrUndefined(this.tabData)) {
      this.loaderService.showLoader();
      let promiseData: Promise<any> = new Promise(() => { });
      if (this.tabData.DocumentType == DocumentType.Training)
        promiseData = this.trainingService.getDownloadUrl(<string>this.portalInfo.SponsorName, <number>this.portalInfo.PortalID, this.tabData.AssetId);
      else if (this.tabData.DocumentType == DocumentType.Document){
        promiseData = this.documentService.downloadFile(<string>this.portalInfo.SponsorName, <number>this.portalInfo.PortalID, args);
        const assetTracking = new AssetTracking();
        assetTracking.AssetId = this.tabData.AssetId;
        assetTracking.ActionId = Actions.Download;
        assetTracking.AssetViewSourceId = AssetViewSources.DocumentCenter; // todo need to confirm
        this.insertAssetTracking(assetTracking);
        
      }
      else if (this.tabData.DocumentType == DocumentType.SafetyReport)
        promiseData = this.communicationService.downloadOriginalFile(<string>this.portalInfo.SponsorName, <number>this.portalInfo.PortalID, this.tabData.AssetId);
      else if (this.tabData.DocumentType == DocumentType.SafetyReportDIL)
        promiseData = this.communicationService.downloadSusarDIL(<any>this.tabData.DILStorageID);
      

      promiseData.then((downloadResponse) => {
        if (downloadResponse.SuccessFlag) {
          if (downloadResponse.UrlType == "zip" || downloadResponse.UrlType == "pdf") {
            const blob = Helpers.b64toBlob(downloadResponse.FileContent, (downloadResponse.UrlType == "zip" ? "application/x-zip" : "application/pdf"));
            FileSaver.saveAs(blob, downloadResponse.FileName);
          } else {
            window.open(downloadResponse.DocumentPath, '_blank', 'noreferrer');
          }
        }
      }, () => {

      }).finally(() => {
        this.loaderService.hideLoader();
      });
    }
  }
  insertAssetTracking(assetTracking:AssetTracking){
          this.documentService.insertAssetTracking(<string>this.portalInfo.SponsorName,assetTracking);
  }

  @HostListener('window:message', ['$event'])
  onMessage(event: any) {
    var data = event.data;
    if (data.func == "DownloadDocument") {
      this.masterLogService.postLogMessage("Click", "Download " + <string>this.tabs[this.tabGroup.selectedIndex!].DocumentType);
      this.DownloadDocument(data.message);
    }
  }

}
